import { STRUCTURES } from "../actions/types";
import {Structure} from "../Structure";

const initialState = {
	structure: Structure
};

export default function(state = initialState, action) {
	switch (action.type) {
		case STRUCTURES:
			return {
				...state
			};
		default:
			return state;
	}
}
